import _ from "lodash";
import moment from "moment";

export default class StringUtils {
    static isValidEmail(str: string): boolean {
        let re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(str).toLowerCase());
    }

    static isValidEmailList(str: string): boolean {
        let self = this;
        let res = true;
        let mails = _.chain(str).split(",").map(_.trim).value();
        _.each(mails, function (mail) {
            res = res && self.isValidEmail(mail);
        });
        return res;
    }

    static html2text(str: string): string {
        let d = document.createElement("div");
        d.innerHTML = str;
        return d.textContent || d.innerText;
    }

    static stripHtmlStyle(str: string): string {
        return str.replace(/((style|class)=".+?")/gim, "");
    }

    static condensateHtml(str: string): string {
        let res = str;
        res = res.replace(/<[^>\/]*>\s*<\/[^>]*>/gim, ""); // remove empty tags
        res = res.replace(/(<br\s*\/?>\s*)+/g, "<br/>"); // remove double <br/>
        return res;
    }

    static encodeHtmlEntities(str: string): string {
        return str.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
            return "&#" + i.charCodeAt(0) + ";";
        });
    }

    static replaceMailParams(body: string): string {
        body = _.replace(body, "{full_date}", moment().format("Do MMMM YYYY"));
        return body;
    }
}
